export class Update {
  id?: number;
  type?: number;
  user_id?: number;
  user_updated_id?: number;
  item_id?: number;
  item_name?: string;
  update_date?: Date;
  update_ip?: string;
  update_agent?: string;
  value_old?: string;
  value_new?: string;
}
